import jadaJpg from './jada-puppy.jpg';
import jadaWebP from './jada-puppy.webp';

export const jadaSources = [jadaWebP, jadaJpg];
